// extracted by mini-css-extract-plugin
module.exports = {"svg":"cursorExternal-module__svg___quRE2","icon":"cursorExternal-module__icon___TjgLB","connect":"cursorExternal-module__connect___8-N3L"};